module.exports = __webpack_public_path__ + "img/char-hu-1.bc7e209d.png";